import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500">91</span>
              <span className="text-xl font-heading font-bold text-foreground-50">片库</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              91片库是您最值得信赖的在线影视资源平台，汇聚海量高清电影、电视剧、综艺及短视频内容，提供极速播放、多线路切换等优质服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#quick-links" className="text-foreground-200 no-underline">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">综艺</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#categories-footer" className="text-foreground-200 no-underline">资源分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#contact-footer" className="text-foreground-200 no-underline">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                <span>support@91piianku.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-customer-service-2-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服 7×24小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 91片库. All rights reserved. 本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">DMCA</a>
          </div>
        </div>
      </div>
    </footer>
  );
}